import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableBulkRefreshRatesOnSuperSelect = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableBulkRefreshRatesOnSuperSelect);
};
